import { isMeituanAppOrWebview, isDianpingAppOrWebview } from '@nibfe/mkt-env-api';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
export const useCommonInfos = () => {
    var _a, _b;
    const ctx = useMonitorEngineContext();
    const isMtAPP = isMeituanAppOrWebview();
    const isDpAPP = isDianpingAppOrWebview();
    const isInApp = isMtAPP || isDpAPP;
    const commonParams = (_b = (_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) !== null && _b !== void 0 ? _b : {};
    return {
        ctx,
        commonParams,
        showToast: ctx._uiInteractionAPI.toast.show,
        isMtAPP,
        isDpAPP,
        isInApp
    };
};
